<template>
  <div class="AgebotOverview">
  <H5 v-if="angebote && angebote.length>0">
    {{ auftrag && auftrag.cutterId ? '1' : '0'}} / {{count('Angenommen')}} / {{angebote.length}}
  </H5>
  </div>
</template>
<script>
export default {
  name: 'AngebotOverview',
  props: ['angebote', 'auftrag'],
  methods: {
    count (status) {
      let cnt = 0
      for (let i = 0; i < this.angebote.length; i++) {
        if (this.angebote[i].auftragAngebotStatus === status) {
          cnt++
        }
      }
      return cnt
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/AngebotOverview.vue